import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	modalTitle: {
		id: 'eoc-feedback-collector.modal-title',
		defaultMessage: 'Share your feedback with us',
		description: 'Title of feedback modal',
	},
	feedbackInputPlaceholder: {
		id: 'eoc-feedback-collector.feedback-input-placeholder',
		defaultMessage:
			"We'd love to know what you like, what you dislike, and what you want to change.",
		description: 'Placeholder value of feedback details input',
	},
	feedbackInputLabel: {
		id: 'eoc-feedback-collector.feedback-input-label',
		defaultMessage: "Tell us what's on your mind",
		description: 'Placeholder value of feedback details input',
	},
});
